export default "/_next/static/chunks/fonts/Copse-Regular-latin-a61fabc745cd5aa6625c1b7fbab44445.woff2";